import { isPowercloudCommunicationRefreshAllowed } from '@core/utils';

export const isPowercloudCommunicationDebugAvailable = (
  mode: string,
): boolean => {
  // Map only explicit Vite modes; unknown modes must not default to Dev.
  const stage =
    mode === 'development' || mode === 'dev'
      ? 'dev'
      : mode === 'staging' || mode === 'stage'
        ? 'stage'
        : undefined;
  return isPowercloudCommunicationRefreshAllowed(stage);
};
